
import * as electronHooks from './useDatabase';
import * as supabaseHooks from './useSupabase';


const isElectron = () => {
    return typeof window !== 'undefined' && window.electronAPI !== undefined;
};


const hooks = isElectron() ? electronHooks : supabaseHooks;

export const useLoans = hooks.useLoans;
export const useLoan = hooks.useLoan;
export const useLoanStats = hooks.useLoanStats;
export const useLoanMutations = hooks.useLoanMutations;
export const useSectors = hooks.useSectors;
export const useCountries = hooks.useCountries;

export const useCovenants = hooks.useCovenants;
export const useCovenantMutations = hooks.useCovenantMutations;

export const useAlerts = hooks.useAlerts;
export const useAlertMutations = hooks.useAlertMutations;

export const useWaivers = hooks.useWaivers;
export const useWaiver = hooks.useWaiver;
export const useWaiverStats = hooks.useWaiverStats;
export const useWaiverMutations = hooks.useWaiverMutations;

export const useAlertStats = hooks.useAlertStats;

export const useDocuments = hooks.useDocuments;
export const useDocumentMutations = hooks.useDocumentMutations;

export const useCovenantHistory = hooks.useCovenantHistory;

export const useImportHistory = hooks.useImportHistory;
export const useImportHistoryMutations = hooks.useImportHistoryMutations;

export const useComplianceHistory = hooks.useComplianceHistory;
export const useAlertsHistory = hooks.useAlertsHistory;
export const useAvgMaturity = hooks.useAvgMaturity;
export const useAtRiskLoans = hooks.useAtRiskLoans;

export const useProfiles = hooks.useProfiles;
export const useProfileMutations = hooks.useProfileMutations;
export const useInvitations = hooks.useInvitations;
export const useInvitationMutations = hooks.useInvitationMutations;

export const useESGMetrics = hooks.useESGMetrics;
export const useESGCovenants = hooks.useESGCovenants;
export const useESGTargets = hooks.useESGTargets;
export const useESGMutations = hooks.useESGMutations;

export { isElectron };